<template>
<div class="flex flex-h-center" @click="sort">
  <slot></slot>
   <span class="caret-wrapper  flex flex-h-center" :class="this.orderBy === this.prop?[val]:[]">
    <i class="sort-caret asc"></i>
    <i class="sort-caret desc"></i>
  </span>
</div>

</template>

<script>
export default {
  props: {
    prop: {
      type: String,
      default: ''
    },
    orderBy: {
      type: String,
      default: ''
    },
    asc: {
      type: Boolean,
      default: false
    },
    desc: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: ''
    };
  },

  mounted() {
    if (this.desc) {
      this.val = 'asc';
    }
    if (this.desc) {
      this.val = 'desc';
    }
  },
  methods: {
    sort() {
      if (this.val === '') {
        this.val = 'asc';
      } else if (this.val === 'asc') {
        this.val = 'desc';
      } else {
        this.val = '';
      }
      this.$emit('sort-change', { prop: this.val === '' ? '' : this.prop, order: this.val });
      // this.sortChange({prop:this.prop,order:this.val})
    },

  }
};
</script>
<style lang="scss">
@import 'style/colors.scss';
// 排序
.caret-wrapper {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  height: 12px;
  width: 12px;
  vertical-align: middle;
  font-size: 14px !important;
  cursor: pointer;
  overflow: initial;
  position: relative;
  overflow: hidden;
  .sort-caret {
    width: 0;
    height: 0;
    border: 3px solid transparent;
    position: absolute;
    left: 6px;
  }

  .sort-caret.asc {
    border-bottom-color: #e6e6e6;
    top: -2.5px;
  }
  .sort-caret {
    border-top-color: #e6e6e6;
    bottom: -1.5px;
  }
}
.asc {
  .sort-caret.asc {
    border-bottom-color: #00a0d9;
  }
}
.desc {
  .sort-caret.desc {
    border-top-color: #00a0d9;
  }
}
</style>
